import styled from 'styled-components';
import { Link } from "gatsby"

export const Container = styled(Link)`
  background: var(--white);
  max-width: 300px;
  width: 300px;
  height: 350px;
  margin: 1rem;
  border-radius: 15px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  transform: scale(1);
  transition: all 0.5s;

  h1,h2 {
    position: relative;
    top: -40px;
  } 
  h2 {
    margin-top: 1rem;
    background: #d3e2f8;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 1rem;
  }

  &:hover{
    transition: all 0.5s;
    transform: scale(1.1);
  }
`;

export const Banner = styled.div`
  display: flex;
  height: 50%;
  width: 100%;
  border-radius: 15px 15px 0 0;
  background: #c7b5b5;
`;

export const Avatar = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  top: -55px;
  border: 3px solid white;

  img {
    border-radius: 50%;
  }
`;